import UtilNumber from "./UtilNumber";

export default class UtilRules{

    static percentage = [
        valor => {
            return UtilNumber.isPercentage(valor);
        }
    ]

    static number = [
        valor =>{
            return UtilNumber.isNumber(valor);
        }
    ]

}